import { actionTypeKeys } from "../actions/actionTypeKeys";
import { AnyAction } from "redux";
import { initialState } from "../store/initialState";
import { AppointmentDto } from "../types/appointment";

export default function appointmentReducer(
  state: AppointmentDto = initialState.appointment,
  action: AnyAction
): AppointmentDto {
  switch (action.type) {
    case actionTypeKeys.SCHEDULE_APPOINTMENT_SUCCESS:
      return action.appointment;
    case actionTypeKeys.CLEAR_APPOINTMENT:
      return initialState.appointment;
    case actionTypeKeys.GET_APPOINTMENT_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
